import { type ReactNode } from "react";
import { useSearchParams } from "react-router-dom";
import ViewSwitch from "@/components/feature/ViewSwitch";
import SiteTop from "@/components/feature/SiteTop";

/* Public case studies with a short and a full version. The full one opens
   first, and a first-visit note on the switch says the short one is the
   quicker read. "?view=short" keeps the short version in the address, so it
   can be shared (the same parameter the NDA case studies use). */
export default function CaseVersions({ short, children }: { short: ReactNode; children: ReactNode }) {
  const [params, setParams] = useSearchParams();
  const view = params.get("view") === "short" ? "short" : "full";
  const choose = (next: "short" | "full") => setParams(next === "short" ? { view: "short" } : {}, { replace: true });

  return (
    <div className="relative with-site-nav">
      <SiteTop />
      <ViewSwitch
        view={view}
        locked={false}
        hints={{
          full: "You are reading the full version. For a quicker read, switch to Short.",
          short: "You are reading the short version. Full goes through every step.",
        }}
        onChange={choose}
      />
      {view === "short" ? short : children}
    </div>
  );
}
